import React, { useState, useEffect } from 'react';
import { Card, Button, List, Typography, Space, Alert } from 'antd';
import { BugOutlined, ReloadOutlined, DeleteOutlined } from '@ant-design/icons';
import simpleErrorHandler from '../utils/simpleErrorHandler';

const { Title, Text } = Typography;

const SimpleErrorViewer: React.FC = () => {
  const [errors, setErrors] = useState<any[]>([]);

  const refreshErrors = () => {
    const errorList = simpleErrorHandler.getErrors();
    setErrors(errorList);
  };

  useEffect(() => {
    refreshErrors();
    // 每3秒刷新一次
    const interval = setInterval(refreshErrors, 3000);
    return () => clearInterval(interval);
  }, []);

  const handleClear = () => {
    simpleErrorHandler.clearErrors();
    refreshErrors();
  };

  const handleTestError = () => {
    try {
      throw new Error('测试错误 - ' + new Date().toLocaleTimeString());
    } catch (error) {
      simpleErrorHandler.logError(error, 'SimpleErrorViewer');
      refreshErrors();
    }
  };

  const handlePrintSummary = () => {
    simpleErrorHandler.printSummary();
  };

  return (
    <div style={{ padding: '20px' }}>
      <Card>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <Title level={3} style={{ margin: 0 }}>
              <BugOutlined /> 简单错误查看器
            </Title>
            <Text type="secondary">查看应用错误记录</Text>
          </div>
          <Space>
            <Button icon={<ReloadOutlined />} onClick={refreshErrors}>
              刷新
            </Button>
            <Button onClick={handleTestError} type="dashed">
              测试错误
            </Button>
            <Button icon={<DeleteOutlined />} onClick={handleClear} danger>
              清空
            </Button>
            <Button onClick={handlePrintSummary}>
              打印摘要
            </Button>
          </Space>
        </div>

        <Alert
          message={`共 ${errors.length} 个错误记录`}
          type="info"
          style={{ marginBottom: '20px' }}
        />

        <List
          dataSource={errors}
          renderItem={(error, index) => (
            <List.Item>
              <div style={{ width: '100%' }}>
                <div style={{ marginBottom: '8px' }}>
                  <Text strong>#{index + 1}</Text>
                  <Text type="secondary" style={{ marginLeft: '10px' }}>
                    {new Date(error.timestamp).toLocaleString()}
                  </Text>
                  <Text code style={{ marginLeft: '10px' }}>
                    {error.context}
                  </Text>
                </div>
                <Text>{error.message}</Text>
                {error.stack && (
                  <pre style={{ 
                    background: '#f5f5f5', 
                    padding: '8px', 
                    borderRadius: '4px',
                    marginTop: '8px',
                    fontSize: '12px',
                    maxHeight: '100px',
                    overflow: 'auto'
                  }}>
                    {error.stack}
                  </pre>
                )}
              </div>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default SimpleErrorViewer;














